module.exports = __webpack_public_path__ + "static/media/ic-good-technic.b28c1789.svg";